import {DateTime} from 'luxon';
import {useMemo, useState} from 'react';
import {useAppSelector} from './redux.ts';
import useVisualizationParams from './useVisualizationParams.ts';
import {useGetCatalogSearch} from '@src/api/catalog';
import {useGetConfigurationLayer} from '@src/api/configurations';

export const useAvailableDates = (
  defaultSearchRange: {
    from: DateTime | null;
    to: DateTime | null;
  },
  options: {enabled?: boolean} = {enabled: true},
) => {
  const [searchRange, setSearchRange] = useState(() => {
    return {
      from: defaultSearchRange.from || DateTime.now().startOf('month'),
      to: defaultSearchRange.to || DateTime.now().endOf('month'),
    };
  });

  const {configurationId, layerId} = useVisualizationParams();
  const layer = useGetConfigurationLayer(configurationId, layerId).data;
  const collectionId = layer?.collectionId;

  const mapExtent = useAppSelector(state => state.map.extent);

  const {data, isLoading} = useGetCatalogSearch<string>(
    {
      bbox: mapExtent ?? undefined,
      datetime: `${searchRange.from.toISO()}/${searchRange.to.toISO()}`,
      collections: [collectionId || ''],
      limit: 65,
      distinct: 'date',
    },
    {enabled: options.enabled},
  );

  const availableDates: DateTime[] = useMemo(() => {
    if (!data?.features) {
      return [];
    }

    return data.features.map((feature: string) => DateTime.fromISO(feature));
  }, [data]);

  return {
    searchRange,
    setSearchRange,
    availableDates,
    isLoading,
  };
};
